import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./RedirectShortLink.css";

// Public page for short links: /s/:code
// Resolves the code via the API and redirects the browser to the real form URL.
// The redirect happens here on the frontend origin (avirtrekkers.com), not as a
// backend redirect.
const RedirectShortLink = () => {
  const { code } = useParams();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/resolve/${code}`)
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => {
        if (cancelled) return;
        if (data && data.longUrl) {
          window.location.replace(data.longUrl);
        } else {
          setFailed(true);
        }
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <div className="redirectShort">
      {failed ? (
        <div className="redirectCard">
          <h2>Link not found</h2>
          <p>This trek link is invalid or has expired.</p>
          <a href="/">Go to home</a>
        </div>
      ) : (
        <div className="redirectCard">
          <div className="spinner" />
          <p>Taking you to the trek registration…</p>
        </div>
      )}
    </div>
  );
};

export default RedirectShortLink;
